import { render, staticRenderFns } from "./ChildrenSummaryBar.vue?vue&type=template&id=8ae0b3a2&scoped=true&"
import script from "./ChildrenSummaryBar.vue?vue&type=script&lang=js&"
export * from "./ChildrenSummaryBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae0b3a2",
  null
  
)

export default component.exports